import { CashDetail } from "../CashDetail";

export class VirtualSafeContent {
    installationName: string = null;
    content: Array<CashDetail> = null;
    timestamp: Date = null;

    public parse(obj: any) {
        if (obj.InstallationName) this.installationName = obj.InstallationName;
        if (obj.Content) {
            this.content = new Array<CashDetail>();
            obj.Content.forEach((t) => {
                let cc = new CashDetail();
                cc.parse(t);
                this.content.push(cc);
            });
        }
        if (obj.Timestamp) this.timestamp = obj.Timestamp;
    }
}
